import * as React from 'react';
import { Grid } from '@mui/material';
import MyOrder from '../../MyOrder/MyOrder';
import Review from '../../Review/Review';

const DashboardHome = () => {

    return (
        <div>
            <MyOrder></MyOrder>
        </div>
    );
};

export default DashboardHome;